<template>
  <section  class="elementor-section elementor-top-section elementor-element elementor-element-1ae2eba elementor-section-boxed elementor-section-height-default elementor-section-height-default" data-id="1ae2eba" data-element_type="section" data-e-type="section">
    <div class="elementor-container elementor-column-gap-no">
      <div class="elementor-column elementor-col-33 elementor-top-column elementor-element elementor-element-b7ebbcf" data-id="b7ebbcf" data-element_type="column" data-e-type="column">
        <div class="elementor-widget-wrap elementor-element-populated">
          <div class="elementor-element elementor-element-544899f elementor-widget elementor-widget-heading" data-id="544899f" data-element_type="widget" data-e-type="widget" data-widget_type="heading.default">
            <div class="elementor-widget-container">
              <h2 class="elementor-heading-title elementor-size-default">{{ homeContentStore.contents.leadership.title }}</h2>
            </div>
          </div>
          <div class="vamtam-has-theme-widget-styles elementor-element elementor-element-1d8dcff vamtam-has-underline-anim elementor-widget elementor-widget-button" data-id="1d8dcff" data-element_type="widget" data-e-type="widget" data-widget_type="button.default">
            <div class="elementor-widget-container">
              <div class="elementor-button-wrapper">
                <a class="elementor-button elementor-button-link elementor-size-sm" href="/leadership/">
                  <span class="elementor-button-content-wrapper">
                    <span class="elementor-button-text">Learn more</span>
                  </span>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="elementor-column elementor-col-66 elementor-top-column elementor-element elementor-element-395132e" data-id="395132e" data-element_type="column" data-e-type="column">
        <div class="elementor-widget-wrap elementor-element-populated">
          <div class="vamtam-has-theme-widget-styles elementor-element elementor-element-1778b56 elementor-grid-1 elementor-posts--thumbnail-left vamtam-has-hr-layout elementor-grid-tablet-1 elementor-posts--thumbnail-mobile-top vamtam-nav-pos-mobile-custom vamtam-has-nav-on-mobile vamtam-nav-pos-custom elementor-grid-mobile-1 vamtam-has-nav vamtam-has-title-underline-anim elementor-widget elementor-widget-global elementor-global-10925 elementor-widget-posts" data-id="1778b56" data-element_type="widget" data-e-type="widget" data-settings="{&quot;vamtam_classic_columns&quot;:&quot;1&quot;,&quot;vamtam_classic_columns_tablet&quot;:&quot;1&quot;,&quot;vamtam_classic_row_gap&quot;:{&quot;unit&quot;:&quot;px&quot;,&quot;size&quot;:0,&quot;sizes&quot;:[]},&quot;vamtam_classic_columns_mobile&quot;:&quot;1&quot;,&quot;vamtam_classic_row_gap_tablet&quot;:{&quot;unit&quot;:&quot;px&quot;,&quot;size&quot;:&quot;&quot;,&quot;sizes&quot;:[]},&quot;vamtam_classic_row_gap_mobile&quot;:{&quot;unit&quot;:&quot;px&quot;,&quot;size&quot;:&quot;&quot;,&quot;sizes&quot;:[]}}" data-widget_type="posts.vamtam_classic">
            <div class="elementor-widget-container">
              <div class="elementor-posts-container elementor-posts elementor-posts--skin-vamtam_classic elementor-grid" role="list">
                <article v-for="leads in homeContentStore.contents.leaderships" :key="leads._id" class="elementor-post elementor-grid-item post-10837 page type-page status-publish has-post-thumbnail hentry" role="listitem">
                  <a class="elementor-post__thumbnail__link" href="#" tabindex="-1">
                    <div class="elementor-post__thumbnail">
                      <img decoding="async" width="798" height="1038" :src="`${leads.image}`" class="attachment-full size-full wp-image-2137" alt="" :data-lazy-srcset="`${leads.image} 798w, ${leads.image} 231w, ${leads.image} 787w, ${leads.image} 768w`" data-lazy-sizes="(max-width: 798px) 100vw, 798px" :data-lazy-src="`${leads.image}`" />
                      <noscript><img loading="lazy" decoding="async" width="798" height="1038" :src="`${leads.image}`" class="attachment-full size-full wp-image-2137" alt="" :srcset="`${leads.image} 798w, ${leads.image} 231w, ${leads.image} 787w, ${leads.image} 768w`" sizes="(max-width: 798px) 100vw, 798px" /></noscript>
                    </div>
                  </a>
                  <div class="elementor-post__text">
                    <h3 class="elementor-post__title">
                      <a href="#" >
                        {{ leads.title }}
                      </a>
                    </h3>
                    <div class="elementor-post__excerpt">
                      <p v-html="leads.descriptions"></p><br />
                      <p v-html="leads.contents"></p>
                    </div>
                  </div>
                </article>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
  import '@splidejs/vue-splide/css';
  import { onMounted } from 'vue'
  import { useHomeContentStore } from '@/stores/homeContentStore'

  export default {
    name: 'LeadershipSectionComponent',
    setup() {
      const homeContentStore = useHomeContentStore()

      onMounted(async () => {
        await homeContentStore.fetchContentPage()
      })

      return {
        homeContentStore
      }
    },
    data() {
      return{
      }
    },
  }
</script>

<style scoped>
  .elementor-1905 .elementor-element.elementor-global-10925 .elementor-post__title, .elementor-1905 .elementor-element.elementor-global-10925 .elementor-post__title a {
    font-size: 24px;
  }
  .elementor-kit-5 h2 {
    font-size: 40px;
  }
</style>